// ─────────────────────────────────────────────────────────────────────────────
// StatCard.js — one KPI tile. `loading` covers both "not fetched yet" and "the
// backend had no reading", and both render the same dashed placeholder: the tile
// never invents a 0 for a number nobody measured.
// ─────────────────────────────────────────────────────────────────────────────
import { TrendIcon } from "./icons";
import styles from "./StatCard.module.css";

/**
 * @param {object}    props
 * @param {string}    props.label      uppercase caption
 * @param {ReactNode} props.value      pre-formatted value (the tile does no maths)
 * @param {string}    [props.unit]     small unit printed after the value
 * @param {"up"|"down"} props.trend
 * @param {string}    props.trendVal   pre-formatted delta, e.g. "+1.2h"
 * @param {ReactNode} props.icon
 * @param {boolean}   props.loading
 */
export default function StatCard({ label, value, unit, trend, trendVal, icon, loading }) {
  return (
    <div className={styles.card}>
      <div className={styles.top}>
        <span className={styles.label}>{label}</span>
        <span className={styles.icon}>{icon}</span>
      </div>

      <div className={styles.value}>
        {loading ? (
          <span className={styles.placeholder}>—</span>
        ) : (
          <>
            {value}
            {unit && <span className={styles.unit}>{unit}</span>}
            <span className={`${styles.trend} ${trend === "up" ? styles.trendUp : styles.trendDown}`}>
              <TrendIcon down={trend !== "up"} />
              {trendVal}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
